import { buildMenuTree, SidebarNavItem } from "@app/core";
import { computed } from "vue";
import { useRouter } from "vue-router";

import type { RouteMeta } from "../types/types";

import { hasPermissions, hasRoles } from "@/shared/permissions";
import { useUserStore } from "@/shared/stores/useUserStore";

export const useMenu = () => {
  const router = useRouter();
  const userStore = useUserStore();

  const menuItems = computed<SidebarNavItem[]>(() =>
    buildMenuTree(
      router
        .getRoutes()
        .filter((route) => {
          const meta = route.meta as RouteMeta;
          return (
            meta.showInMenu !== false
            && meta.requiresAuth !== false
            && !meta.isRootRedirect
            && !route.redirect
            && !route.path.includes("*")
            && route.name
            // Role gate — menu items hidden if user's role isn't allowed
            && hasRoles(meta.roles, userStore)
            // Permission gate — menu items hidden if user lacks required permissions
            && hasPermissions(meta.permissions, userStore)
          );
        })
        .map((route) => {
          const meta = route.meta as RouteMeta;
          return {
            item: {
              id: String(route.name),
              label: meta.menuTitle || meta.title || String(route.name),
              icon: meta.menuIcon,
              badge: meta.menuBadge,
              order: meta.menuOrder ?? 999,
              to: { name: String(route.name) },
            } satisfies SidebarNavItem,
            meta,
          };
        }),
    ),
  );

  return { menuItems };
};
